import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { getFromStorage } from '../../../helpers/storageUtils';

@Component({
  selector: 'app-inspection-banner',
  templateUrl: './inspection-banner.component.html',
  styleUrl: './inspection-banner.component.scss',
  standalone: true,
  imports: [CommonModule],
})
export class InspectionBannerComponent implements OnInit {
  title = signal('Tu seguro puede requerir inspección');
  toastDescription = signal(
    'Si aplica en tu caso, te llegará un correo con la fecha límite para hacerla. No olvides completarla a tiempo, de lo contrario tu seguro se cancelará.',
  );
  isClose = signal(false);

  OnerousValue = getFromStorage('OnerousSelection', 'session') || '';

  ngOnInit(): void {
    this.handleBannerInformation();
  }

  handleBannerInformation(): void {
    if (this.OnerousValue === 'Prenda' || this.OnerousValue === 'PrendaAccesorios') {
      this.title.set('¡Podrías necesitar una inspección!');
      this.toastDescription.set(
        'En algunos casos, las motos financiadas pueden necesitar una inspección antes de comprar. Si llega a aplicar, te ayudaremos con el proceso.',
      );
      this.isClose.set(true);
    }

    if (this.OnerousValue === 'Accesorios') {
      this.title.set('¡Podrías necesitar una inspección!');
      this.toastDescription.set(
        'En las próximas 24 horas te enviaremos un correo para confirmar si tu vehículo requiere inspección',
      );
      this.isClose.set(true);
    }
  }

  handleClose() {
    this.isClose.update((currentValue) => !currentValue);
  }
}
